import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

export default function MyBookings() {
  const [bookings, setBookings] = useState([]);
  useEffect(() => { api.get("/my/bookings").then(r => setBookings(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-4xl mx-auto px-5 lg:px-8 py-10">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]" data-testid="my-bookings-title">My bookings</h1>
      {bookings.length === 0 ? (
        <div className="mt-8 p-6 border border-dashed border-slate-200 rounded-2xl text-slate-500 text-sm" data-testid="my-bookings-empty">
          You have no bookings yet. <Link to="/" className="underline font-semibold text-[var(--fpn-navy)]">Search parking →</Link>
        </div>
      ) : (
        <div className="mt-6 space-y-3">
          {bookings.map(b => (
            <Link to={`/booking/${b.reference}`} key={b.id} className="block border border-slate-200 rounded-2xl p-5 bg-white card-lift" data-testid={`my-booking-${b.reference}`}>
              <div className="flex justify-between items-center flex-wrap gap-3">
                <div>
                  <div className="font-semibold text-[var(--fpn-navy)]">{b.parking_name}</div>
                  <div className="text-sm text-slate-500">{b.airport_code} · {new Date(b.dropoff).toLocaleDateString("en-GB")} → {new Date(b.pickup).toLocaleDateString("en-GB")}</div>
                </div>
                <div className="text-sm font-mono text-slate-500">{b.reference}</div>
                <div className="font-display text-xl font-bold text-[var(--fpn-navy)]">£{b.total_price.toFixed(2)}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
